import { render, staticRenderFns } from "./listCalorie.vue?vue&type=template&id=088de97e&scoped=true&"
import script from "./listCalorie.vue?vue&type=script&lang=js&"
export * from "./listCalorie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088de97e",
  null
  
)

export default component.exports